<template lang='pug'>
  .media-type-item
    el-row.title-row(
      :gutter="20"
    )
      el-col(:span="10") {{ $t('媒体形式') }}
      el-col(:span="10") {{ $t('媒体预算') }}
    el-row.content-row(
      :gutter="20"
    )
      el-col(:span="10") {{ item.media_type_category_name }}
      el-col(:span="10") {{ item.budget / 10000 | numberWithCommas(1) }} {{ $t('万元') }}
    .campaign-io-view(v-if="item.media_type_io.length !== 0")
      div(
        v-for="v in item.media_type_io"
      )
        template(
          v-for="(item, idx) in v.media_type_io_rel"
        )
          el-row.title-row(
            :gutter="20"
          )
            el-col(:span="10") {{ $t('IO号') }}
          el-row.content-row(
            :gutter="20"
          )
            el-col(:span="10") {{ item.io }}
        el-row.title-row(
          :gutter="20"
        )
          el-col(:span="10") {{ $t('IO附件') }}
        el-row.content-row(
          :gutter="20"
        )
          el-col(
            :span="20"
          )
            a(
              :href="v.io_download_url"
            ) {{ v.io_file_name }}
    .target-audience-view
      .target-audience-item(
        v-for="v in item.media_type_target_audiences"
      )
        el-row.title-row(
          :gutter="20"
        )
          el-col(:span="10") {{ $t('目标投放群体') }}
        el-row.content-row(
          :gutter="20"
        )
          el-col(:span="10")
            span {{ v.target_audiences_name }}
            span(v-if="v.is_synchronized === 1") （{{ $t('已同步至投放后台') }}）
        el-row.title-row(
          :gutter="20"
        )
          el-col(:span="10") {{ $t('页面/产品链接') }}
        el-row.content-row(
          :gutter="20"
        )
          el-col(:span="10")
            a(
              :href="v.url"
              target="_blank"
            ) {{ v.url }}
        el-row.title-row(
          :gutter="20"
        )
          el-col(:span="10") {{ $t('预算') }}
        el-row.content-row(
          :gutter="20"
        )
          el-col(:span="10") {{ v.budget / 10000 | numberWithCommas(1) }} {{ $t('万元') }}
        template(
          v-if="showMaterialInfo || (subFinalScopeInfo && subFinalScopeInfo.is_bypass)"
        )
          el-row.title-row(
            :gutter="20"
            v-if="v.media_type_target_audiences_id && v.media_type_target_audiences_material.length !== 0"
          )
            el-col(:span="10") {{ $t('素材') }}
            el-col
              el-button(
                style="margin-top: 12px"
                @click="handleDownloadPack(v.media_type_target_audiences_id)"
                type="primary"
              ) {{ $t('打包下载') }}
          el-row.title-row(
            :gutter="20"
          )
            el-col(:span="10") {{ $t('素材上传') }}
          div
            image-view-container(
              v-if="v.media_type_target_audiences_material.length !== 0"
              :items="v.media_type_target_audiences_material"
            )
            span(v-else style="margin-bottom: 22px;display:flex") —
          el-row(
            v-for="(o, idx) in item.media_type_qualify_info"
            :key="idx"
            :gutter="20"
          )
            el-col.title-row(
              v-if="idx === 0"
              style="width: 180px"
            ) {{ $t('资质信息') }}
            el-col(
              :span="17"
              :class="[idx !== 0 ? 'qualify-info-row' : '']"
            )
              span(style="margin-right: 10px") {{ o.qualify_info_name }}
              a(
                :href="o.file_download_path"
              ) {{ o.file_name }}
    el-row.title-row(
      :gutter="20"
    )
      el-col(:span="10") {{ $t('KPI') }}
    el-row.content-row(
      :gutter="20"
    )
      el-col(:span="10") {{ item.kpi_name }}
    el-row.title-row(
      :gutter="20"
    )
      el-col(:span="10") {{ $t('是否需要投放实时优化') }}
      el-col(:span="10") {{ $t('投放介绍') }}
    el-row.content-row(
      :gutter="20"
    )
      el-col(:span="10") {{ item.is_real_time === 1 ? $t('是') : $t('否') }}
      el-col(:span="10") {{ item.other_require == null || item.other_require == 'null' ? '—' : item.other_require }}
</template>

<script>
import axios from 'axios'
import { numberWithCommas } from '@/umcc/util'
import ImageViewContainer from './ImageViewContainer'
export default {
  components: {
    ImageViewContainer
  },
  data () {
    return {
    }
  },
  filters: {
    numberWithCommas
  },
  computed: {
    subFinalScopeInfo () {
      return this.$store.state.campaign.subFinalScopeInfo
    }
  },
  props: {
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    showMaterialInfo: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleDownloadPack (id) {
      this.loading = true
      axios.get('/management/ec/downloadTAMaterial', {
        params: {
          media_type_target_audiences_id: id
        }
      })
        .then(res => {
          this.loading = false
          window.open(res.download_url, '_blank')
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    }
  }
}
</script>

<style lang='stylus'>
.media-type-item
  .qualify-info-row
    margin-left 180px
</style>
